import { FeatureOwners } from '@/scopes/common/infrastructure/feature-flags/constants'
import { flag } from '@/scopes/common/infrastructure/feature-flags/flag'

export const FEATURE_FLAGS = {
  ACTIVATE_DK_SEARCH: flag({ name: 'DK Search', owner: FeatureOwners.BAHAMAS }),
  SHOW_GROUPS_BUS_MORE_THAN_ONE_PICKUP_POINT: flag({
    name: 'Show groups bus more than one pickup point',
    owner: FeatureOwners.KOS,
  }),
  SHOW_GROUPS_BUS_PICKUP_POINT_KNOWN: flag({
    name: 'Show groups bus pick point known',
    owner: FeatureOwners.KOS,
  }),
  BAHAMAS_ENABLE_COUNTDOWNS: flag({
    name: '',
    owner: FeatureOwners.BAHAMAS,
  }),
  BAHAMAS_ENABLE_PROMOTED_PRICE_REFRESH: flag({
    name: 'Enable Promoted Price refresh',
    owner: FeatureOwners.BAHAMAS,
  }),
  BAHAMAS_ENABLE_AI_FILTER_WG: flag({
    name: 'Enable AI Filter for WG publication',
    owner: FeatureOwners.BAHAMAS,
  }),
  BAHAMAS_ENABLE_DYNAMIC_FILTERS: flag({
    name: 'ENABLE DYNAMIC FILTERS COMPONENT ON SEARCH PAGES',
    owner: FeatureOwners.BAHAMAS,
  }),
  BAHAMAS_ENABLE_AIRLINE_FILTER: flag({
    name: 'Enable Airline filter on search pages',
    owner: FeatureOwners.BAHAMAS,
  }),
  RIO_ENABLE_GROUP_RESPONSIBLE_ROOM_ASSIGNMENT: flag({
    name: 'Enable room assignment on group responsible page',
    owner: FeatureOwners.RIO,
  }),
  RIO_ENABLE_BOOKING_PREFERENCES_EDIT: flag({
    name: 'Enable editing accommodation preferences on the Booking Details page',
    owner: FeatureOwners.RIO,
  }),
  MAUI_ENABLE_WEB_EXPERIMENTATION: flag({
    name: 'Enable Web Experimentation',
    owner: FeatureOwners.MAUI,
  }),
  MVC_PAGES_LOAD_OPTIMIZELY_SDK: flag({
    name: 'On MVC pages, load the Optimizely client SDK to send events from GTM to Feature Experimentation.',
    owner: FeatureOwners.MAUI,
  }),
  KYOTO_GTM_WAIT_FOR_COOKIE_CONSENT: flag({
    name: 'GTM script waits for cookie consent',
    owner: FeatureOwners.KYOTO,
  }),
  KYOTO_USE_TAGGRS_SCRIPT: flag({
    name: 'Use Taggrs script',
    owner: FeatureOwners.KYOTO,
  }),
  ENABLE_MY_ACCOUNT_PAYMENT_PAGE: flag({
    name: 'Enable My Account Payment Page',
    owner: FeatureOwners.KOS,
  }),
  KOS_ENABLE_MY_ACCOUNT_GROUPS_PAYMENT_PAGE: flag({
    name: 'Enable My Account Groups Payment Page '
      + '(if this flag is enabled customers will be redirected always to the new url)',
    owner: FeatureOwners.KOS,
  }),
  KOS_ENABLE_MY_ACCOUNT_GROUPS_PAYMENT_MVC_PAGE: flag({
    name: 'Enable My Account Groups Payment MVC Page '
      + '(while the new booking details page for groups is not ready)(if this flag is enabled customers will see the React page in the current url)',
    owner: FeatureOwners.KOS,
  }),
  KOS_ENABLE_EMAIL_FIELD_PARTICIPANTS_BADGE: flag({
    name: 'Enable email address field in participants badge',
    owner: FeatureOwners.KOS,
  }),
  KOS_ENABLE_SEND_EVENT_NEXTBUTTON_STEP1: flag({
    name: 'Enable send event on next button click in step 1',
    owner: FeatureOwners.KOS,
  }),
  KOS_ENABLE_MANDATORY_PAYMENT_PAGE: flag({
    name: 'Enable Mandatory Payment checkout page',
    owner: FeatureOwners.KOS,
  }),
  MALLORCA_ENABLE_NEW_BASKET: flag({
    name: 'Enable new Basket design in checkout',
    owner: FeatureOwners.MALLORCA,
  }),
  MALLORCA_ENABLE_NEW_STEP_4_PAGE: flag({
    name: 'New Step 4 page in React',
    owner: FeatureOwners.MALLORCA,
  }),
  RIO_ENABLE_REACT_LOGIN_PAGE: flag({
    name: 'Enable React Login Page',
    owner: FeatureOwners.RIO,
  }),
  RIO_ENABLE_REACT_VERIFY_PAGE: flag({
    name: 'Enable React Verify Account Page',
    owner: FeatureOwners.RIO,
  }),
  RIO_ENABLE_REACT_SET_PASSWORD_PAGE: flag({
    name: 'Enable React Set Password Page',
    owner: FeatureOwners.RIO,
  }),
} as const

export const ACTIVE_FEATURE_FLAGS: FeatureFlagId[] = []

export type FeatureFlagId = keyof typeof FEATURE_FLAGS
